"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    BS = require('react-bootstrap'),
    cx = require('classnames'),
    Constants = require('../../constants'),
    Cmp = require('../../components'),
    Validation = require('../../partials/validation'),
    URI = require('urijs'),
    Model = require('../../models/Model'),
    Contact = Model.extend({
        validation: {
            message: {
                required: true
            }
        },

        getDefaults: function() {
            return {
                message: '',
                copyMe: false,
                saveOnOwnLine: false,
                smallHeader: false,
                hideValidationMessage: false
            };
        }
    });

var BuilderContactForm = React.createClass({displayName: "BuilderContactForm",
    contextTypes: {
        router: React.PropTypes.func
    },

    getDefaultProps: function() {
        return {
            contact: new Contact()
        };
    },

    updateState: function() {
        return {
            success: undefined
        };
    },

    getInitialState: function() {
        return this.updateState();
    },

    componentWillMount: function() {
        this.props.contact.clear();
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            header = (
                React.createElement("h2", {className: 'orange-text' + (props.smallHeader ? ' font-small' : '')}, "Send Builder a Quick Message:")
            )

        return (
            React.createElement(BS.Panel, {className: "margin-bottom-10 panel-no-header", header: header}, 
                React.createElement("p", null, 
                    "Questions, concerns, inquires, suggestions? Use the form to send representatives for ", React.createElement("span", {className: "blue-text"}, props.model.get('name')), " a quick message."
                ), 
                state.success && (
                    React.createElement(BS.Alert, {bsStyle: "success"}, 
                        "Message Sent."
                    )
                ), 
                React.createElement(Validation.Form, {ref: "form", hidden: state.success, horizontal: false, model: props.contact, validateOnLoad: false, onSubmit: this.onSubmit}, 
                    React.createElement(Validation.Input, {type: "textarea", trigger: "onChange", name: "message", label: "Message:"}), 

                    !props.hideValidationMessage && (
                        React.createElement(Cmp.ValidationMessage, {action: "Send"})
                    ), 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: props.saveOnOwnLine ? 'col-xs-12' : 'col-sm-6'}, 
                            React.createElement(Validation.Input, {type: "checkbox", useCheckedLink: true, groupClassName: "margin-bottom-0", wrapperClassName: "pull-left", label: "Send me a copy of this message", name: "copyMe"})
                        ), 
                        React.createElement("div", {className: props.saveOnOwnLine ? 'col-xs-12' : 'col-sm-6'}, 
                            React.createElement(Cmp.Button.Save, {className: "pull-right"}, React.createElement("i", {className: "fa fa-envelope"}), " Send")
                        )
                    )
                )
            )
        );
    },

    onSubmit: function(e) {
        this.doSubmit();
    },

    doSubmit: function() {
        var me = this,
            state = me.state,
            props = me.props;
        if (this.refs.form.isValid()) {
            props.model.contactBuilder(this.refs.form.getValues()).then(function() {
                me.setState({
                    success: true
                });
            });
        }
    },

    getMessage: function(type, model_collection, response, options) {
        return 'Contact Failed. Please try again.';
    }
});
module.exports = BuilderContactForm;
